module.exports = __webpack_public_path__ + "media/short-normal-clapping.50fcf3f0.mp3";